import { Card, CardContent } from '@/components/ui/card';

interface RoundReviewPanelProps {
  roundType: string;
  raiseAmount: number;
  currency: string;
  preMoney: number;
  instrument: string;
  optionPoolIncrease: number;
  leadInvestor: string;
  valuationCap: number;
  discountRate: number;
}

export function RoundReviewPanel(props: RoundReviewPanelProps) {
  const {
    roundType,
    raiseAmount,
    currency,
    preMoney,
    instrument,
    optionPoolIncrease,
    leadInvestor,
    valuationCap,
    discountRate,
  } = props;

  const postMoney = preMoney + raiseAmount;
  const investorPct =
    raiseAmount > 0 && postMoney > 0 ? ((raiseAmount / postMoney) * 100).toFixed(1) : '—';

  const fmt = (n: number) => {
    if (!n) return '—';
    const sym = currency === 'USD' ? '$' : currency + ' ';
    return n >= 1_000_000 ? `${sym}${(n / 1_000_000).toFixed(1)}M` : `${sym}${n.toLocaleString()}`;
  };

  const typeLabel = roundType.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

  const items: { label: string; value: string }[] = [
    { label: 'Round type', value: typeLabel },
    { label: 'Instrument', value: instrument },
    { label: 'Raise target', value: fmt(raiseAmount) },
    { label: 'Pre-money valuation', value: fmt(preMoney) },
    { label: 'Post-money valuation', value: fmt(postMoney) },
    { label: 'Investor dilution', value: `${investorPct}%` },
  ];

  if (optionPoolIncrease > 0)
    items.push({
      label: 'Option pool increase',
      value: `${(optionPoolIncrease * 100).toFixed(1)}%`,
    });
  if (leadInvestor) items.push({ label: 'Lead investor', value: leadInvestor });
  if (instrument === 'SAFE' || instrument === 'CONVERTIBLE_NOTE') {
    if (valuationCap) items.push({ label: 'Valuation cap', value: fmt(valuationCap) });
    if (discountRate) items.push({ label: 'Discount rate', value: `${discountRate}%` });
  }

  return (
    <Card>
      <CardContent className="p-6 divide-y divide-border/60">
        {items.map((item) => (
          <div
            key={item.label}
            className="flex items-center justify-between py-3 first:pt-0 last:pb-0"
          >
            <span className="text-sm text-muted-foreground">{item.label}</span>
            <span className="text-sm font-medium tabular-nums">{item.value}</span>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
